import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-time-picker',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.scss'
})
export class TimePickerComponent implements OnInit {
  @Input() value: string = '';
  @Input() placeholder: string = 'Select time';
  @Input() disablePastTimes: boolean = false;
  @Input() minDate: string = '';
  @Output() valueChange = new EventEmitter<string>();

  show = false;
  timeSlots: string[] = [];

  ngOnInit(): void {
    this.timeSlots = this.buildSlots();
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.show = false;
  }

  toggle(event: MouseEvent) {
    event.stopPropagation();
    this.show = !this.show;
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }

  isPastTime(slot: string): boolean {
    if (!this.disablePastTimes || !this.minDate) return false;

    const now = new Date();
    const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    if (this.minDate !== todayStr) return false;

    const lower = slot.toLowerCase();
    const isPm = lower.includes('pm');
    const [hStr, mStr] = lower.replace(/am|pm/, '').split(':');
    let h = parseInt(hStr, 10);
    const m = parseInt(mStr, 10);
    if (isPm && h !== 12) h += 12;
    if (!isPm && h === 12) h = 0;

    return h * 60 + m <= now.getHours() * 60 + now.getMinutes();
  }

  selectTime(slot: string) {
    if (this.isPastTime(slot)) return;
    this.valueChange.emit(slot);
    this.show = false;
  }

  private buildSlots(): string[] {
    const slots: string[] = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const h12 = h % 12 || 12;
        const ap = h < 12 ? 'am' : 'pm';
        slots.push(`${h12}:${m.toString().padStart(2, '0')}${ap}`);
      }
    }
    return slots;
  }
}
